

// NewUpcomingProjects.jsx

import React, { useEffect, useState } from "react";
import "./upcomingprojectsblue.css";

import Slider from "react-slick";

import HomeService from "../../../Services/HomeService";

import { toast } from "react-toastify";

import ReelsPlayer from ".././ReelsPlayer/ReelsPlayer";

import { FaPlay } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { HiOutlineLocationMarker } from "react-icons/hi";

const NewUpcomingsProjectsBlue = () => {

  const [reels, setReels] = useState([]);

  const [selectedReel, setSelectedReel] = useState(null);

  const [isReelsPlayerOpen, setIsReelsPlayerOpen] =
    useState(false);


  const [playingVideos, setPlayingVideos] = useState({});

  // play videos
  const handlePlay = (id) => {
    setPlayingVideos((prev) => ({
      ...prev,
      [id]: true,
    }));
  };

  /* =========================
     FETCH REELS
  ========================= */

  const fetchReels = async () => {

    try {

      const res = await HomeService.getReels();

      console.log("reels", res);

      if (res?.status) {
        setReels(res?.data);
      } else {
        toast.error(res?.message);
      }

    } catch (error) {

      console.log(error);

      toast.error(error?.message);

    }
  };

  useEffect(() => {
    fetchReels();
  }, []);

  /* =========================
     OPEN PLAYER
  ========================= */

  const handleReelClick = (reel) => {

    setSelectedReel(reel);

    setIsReelsPlayerOpen(true);
  };

  /* =========================
     CLOSE PLAYER
  ========================= */

  const handleCloseReelsPlayer = () => {

    setIsReelsPlayerOpen(false);

    setSelectedReel(null);
  };

  // esc key close
  useEffect(() => {
    const handleEscKey = (event) => {
      if (
        event.key === "Escape" &&
        isReelsPlayerOpen
      ) {
        handleCloseReelsPlayer();
      }
    };

    document.addEventListener(
      "keydown",
      handleEscKey
    );

    return () => {
      document.removeEventListener(
        "keydown",
        handleEscKey
      );
    };
  }, [isReelsPlayerOpen]);

  /* =========================
     SLIDER
  ========================= */

  const settings = {
    dots: false,
    infinite: true,
    speed: 700,
    autoplay: true,
    autoplaySpeed: 2500,
    pauseOnHover: true,
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 1,

    responsive: [

      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
        },
      },

      {
        breakpoint: 980,
        settings: {
          slidesToShow: 2,
        },
      },

      {
        breakpoint: 580,
        settings: {
          slidesToShow: 1,
        },
      },

    ],
  };

  return (
    <>

      <section className="upcomingx-main-section_blue">

        {/* TOP */}

        <div className="elitefame-top-wrapper_blue">

          <span className="upcomingx-subtitle_blue">
            Future Developments
          </span>

          <h2 className="insightx-title_n_blue">
            Our Upcoming Projects
          </h2>

        </div>

        {/* <div className="upcomingx-top-wrapper">

          <div className="elitefame-top-wrapper">

            <span className="upcomingx-subtitle">
              Future Developments
            </span>

            <h2 className="insightx-title_n">
              Our Upcoming Projects
            </h2>

          </div>

          <button className="upcomingx-view-btn">
            Explore More
          </button>

        </div> */}

        {/* SLIDER */}

        <div className="upcomingx-slider-wrapper_blue">
          <Slider {...settings}>
            {reels?.map((reel, i) => (
              <div key={i}>
                <div className="reel-card-blue">

                  {!playingVideos[reel?._id] ? (
                    <>
                      <img
                        src={
                          reel?.thumbnail ||
                          "https://static.vecteezy.com/system/resources/thumbnails/040/813/403/small/building-design-render-photo.jpg"
                        }
                        alt=""
                        className="reel-thumbnail-blue"
                      />

                      <div className="reel-overlay-blue" />

                      <button
                        className="reel-play-btn-blue"
                        onClick={() =>
                          handlePlay(reel?._id)
                        }
                      >
                        <FaPlay />
                      </button>
                    </>
                  ) : (
                    // <video
                    //   className="reel-video-blue"
                    //   src={reel?.video}
                    //   controls
                    //   autoPlay
                    //   playsInline
                    //   loop
                    // />

                    <video
  className="reel-video-blue"
  src={reel?.video}
  controls
  autoPlay
  playsInline
  loop
  onPlay={() =>
    setPlayingVideos((prev) => ({
      ...prev,
      [reel._id]: true,
    }))
  }
  onPause={() =>
    setPlayingVideos((prev) => ({
      ...prev,
      [reel._id]: false,
    }))
  }
  onEnded={() =>
    setPlayingVideos((prev) => ({
      ...prev,
      [reel._id]: false,
    }))
  }
/>
                  )}

                  {/* <div className="reel-content-blue">
            <h3>{reel?.title || "Project Reel"}</h3>
          </div> */}
                  <div
                    className={`reel-content-blue ${playingVideos[reel._id]
                        ? "hide-content"
                        : ""
                      }`}
                  >
                    <h3>{reel?.title || "Project Reel"}</h3>
                  </div>

                </div>
              </div>
            ))}
          </Slider>
        </div>

      </section>

      {/* =========================
          MODAL
      ========================= */}

      {isReelsPlayerOpen &&
        selectedReel && (

          <div
            className="upcomingx-modal-overlay_blue"
            onClick={
              handleCloseReelsPlayer
            }
          >

            <div
              className="upcomingx-modal-content_blue"
              onClick={(e) =>
                e.stopPropagation()
              }
            >

              {/* CLOSE */}

              <button
                className="upcomingx-close-btn_blue"
                onClick={
                  handleCloseReelsPlayer
                }
              >

                <IoClose />

              </button>

              {/* VIDEO */}

              <ReelsPlayer
                videoUrl={
                  selectedReel?.video
                }
                autoPlay={true}
                muted={false}
                controls={true}
                loop={true}
              />

            </div>

          </div>

        )}

    </>
  );
};

export default NewUpcomingsProjectsBlue;